import { IDENTITY_TYPE } from 'common/constants/Types';

/** 认证流类型 */
export enum FLOW_TYPE {
  /** 使用oneid登录页 */
  DELEGATION = 'Delegation',
  /** 跳转到三方认证源登录页 */
  REDIRECT = 'Redirect',
}
/** 账密登录的下步操作 */
export enum USERNAME_LOGIN_RES_TYPES {
  /** 验证码 */
  CAPTCHA_OPTIONS = 'CAPTCHA_OPTIONS',
  /** 重置密码 */
  ACCOUNT_RESET_PASSWORD = 'ACCOUNT_RESET_PASSWORD',
}

/** 展示输入的字段名 */
export const USERNAME_LABEL = {
  [IDENTITY_TYPE.AD]: 'Active Directory',
  [IDENTITY_TYPE.OPENLDAP]: 'Open LDAP',
  [IDENTITY_TYPE.PASSWORD]: '',
};
